export default __webpack_public_path__ + "static/media/passtrack_header_white.51b2e722.png";